import { ApiClient } from "@/api-client/src/core/api-client";
import { LoginResponse } from "@/packages/types/auth";

const apiClient = new ApiClient();
const webService = apiClient.web;

/**
 * Logs in the user with email and password.
 */
export const loginUser = async (
  email: string,
  password: string
): Promise<LoginResponse> => {
  const response = await webService.post<LoginResponse>("/auth/login", {
    email,
    password,
  });
  return response;
};
export const registerUser = async (data: {
  email: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  password: string;
}): Promise<LoginResponse> => {
  const response = await webService.post<LoginResponse>("/auth/register", data);
  return response;
};

export const checkEmailExists = async (email: string): Promise<boolean> => {
  try {
    const response = await webService.post<{ data: { exists: boolean } }>(
      "/auth/check-email",
      { email }
    );
    return response.data?.exists ?? false;
  } catch (error) {
    console.error("Error checking email existence:", error);
    return false;
  }
};
